<template>
    <div class="version1-right-top-header">
        <div class="version1-left-top-text">
            <img src="../../../../../static/version1/标题箭头左.png" alt="">
            <span>{{ title }}</span>
        </div>
        <img src="../../../../../static/version1/左边板块标题样式.png" alt="" class="line">
    </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {

    }
  }
}
</script>
